<template>
  <div>
    <b-row class="card-body">
      <b-col cols="12">
        <div v-if="contentIsLoading" class="text-center mt-5 mb-5">
          <b-spinner type="grow" variant="primary"/>
        </div>

        <div v-else>
          <b-row>
            <b-col cols="12">
              <div class="pull-right mb-3">
                <b-button variant="primary" class="mt-1" :disabled="!actions.create"
                          @click="setItemData([], true)">
                  <i class="fa fa-plus mr-2"/>{{ 'add_new' | translate('global') }}
                </b-button>
              </div>
            </b-col>

            <b-col cols="12">
              <Item v-if="activeItem !== null"
                    :data="activeItem"
                    :isNew="isActiveItemNew"
                    @cancel="clearActiveItem()"/>
            </b-col>
            <b-col cols="12">
              <EmptyTable v-if="!isItems" :values="emptyTableValues" />
              <b-table v-else class="table-sm text-center"
                       responsive bordered :fields="tableFields" :items="tableItems">
                <template v-slot:options="row">
                  <i v-if="!actions.create" class="fa fa-copy fa-lg fa-secondary-disabled mr-3"/>
                  <i v-else class="fa fa-copy fa-lg fa-color-info mr-3" @click="setItemData(row.item.item, true)"/>

                  <i v-if="activeItem && activeItem.id === row.item.id && !isCreatingCopy"
                     class="fa fa-pencil fa-lg fa-secondary-disabled"/>
                  <i v-else @click="setItemData(row.item.item, false)" class="fa fa-edit fa-lg fa-primary"/>
                </template>
              </b-table>
            </b-col>
          </b-row>

        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import VuexTypes from '@/store/types/index';
import { mapGetters, mapActions } from 'vuex';
import statuses from '@/store/statuses';
import forEach from 'lodash.foreach';
import EmptyTable from '@/views/sharedComponents/EmptyTableData';
import Item from './Item.vue';

const OrdersTypes = VuexTypes.orders;
export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      isItems: null,
      isActiveItemNew: false,
      activeItem: null,
      isCreatingCopy: false,
      spinners: {
        isSaving: false,
      },
      actions: {},
      emptyTableValues: {
        text: this.$t('no_items_for_this_order', 'global')
      },
      tableFields: [
        { key: 'product_service', label: this.$t('product_service', 'global') },
        { key: 'amount', label: this.$t('amount', 'global') },
        { key: 'unit', label: this.$t('unit', 'global') },
        { key: 'unit_price', label: this.$t('unit_price', 'global') },
        { key: 'price', label: this.$t('price', 'global') },
        { key: 'warehouse', label: this.$t('warehouse', 'global') },
        { key: 'transport', label: this.$t('transport', 'global') },
        { key: 'options', label: this.$t('options', 'global') }
      ],
      tableItems: [],
    };
  },
  components: { EmptyTable, Item },
  computed: {
    ...mapGetters('Orders', [
      'orderApproval',
      'ordersClassifiers',
      'orderCreateItem',
      'orderUpdateItem',
      'orderDeleteItem',
      'orderItems'
    ]),
    contentIsLoading() {
      if (this.orderItems.status === statuses.LOADED && this.ordersClassifiers.status === statuses.LOADED) {
        return false;
      }
      return true;
    }
  },
  watch: {
    orderApproval: {
      handler: function () {
        if (this.orderApproval.status === statuses.LOADED) {
          this.getData();

        }
      },
      deep: true
    },
    orderItems: {
      immediate: true,
      handler: function () {
        if (this.orderItems.status === statuses.LOADED) {
          this.actions = this.orderItems.data.actions ? this.orderItems.data.actions : {};
          this.isItems = this.orderItems.data['order_items'] ? this.orderItems.data['order_items'].length : null;
          this.fillData();
        }
      },
      deep: true
    },
    orderCreateItem: {
      handler: function () {
        if (this.orderCreateItem.status === statuses.LOADED) {
          this.setItemData(this.orderCreateItem.data, false);
          this.getData();
          this.$emit('getData');
        }
      },
      deep: true
    },
    orderUpdateItem: {
      handler: function () {
        if (this.orderUpdateItem.status === statuses.LOADED) {
          this.alertSuccess();
          this.getData();
          this.$emit('getData');
          this.activeItem = this.orderUpdateItem.data;
        }
      },
      deep: true
    },
    orderDeleteItem: {
      handler: function () {
        if (this.orderDeleteItem.status === statuses.LOADED) {
          this.getData();
          this.clearActiveItem();
          this.$emit('getData');
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Orders', [
      OrdersTypes.ORDER_ITEMS
    ]),
    getData() {
      this.ORDER_ITEMS(this.$route.params.id);
    },
    setItemData(activeItem, isActiveItemNew) {
      if (isActiveItemNew && Object.keys(activeItem).length) {
        this.isCreatingCopy = true;
      } else {
        this.isCreatingCopy = false;
      }
      this.isActiveItemNew = isActiveItemNew;
      this.activeItem = activeItem;
    },
    fillData() {
      const items = this.orderItems.data['order_items'] ? this.orderItems.data['order_items'] : [];
      const result = [];
      if (items.length) {
        forEach(items, (item) => {
          result.push({
            id: item['id'],
            item: item,
            product_service: item['product'] ? item['product']['full_name'] : null,
            amount: item.quantity,
            unit: item['units_classifier'] ? item['units_classifier']['name'] : null,
            unit_price: item['price'],
            price: item['total'],
            warehouse: item['warehouses_classifier'] ? item['warehouses_classifier']['name'] : '-',
            transport: item['transports_classifier'] ? item['transports_classifier']['ax_code'] : '-'
          });
        });
      }
      this.tableItems = result;
    },
    clearActiveItem() {
      this.activeItem = null;
      this.isActiveItemNew = false;
    },
  }
};

</script>
